<template>
  <div class="login" :style="{ backgroundImage: `url(${bgImg})` }">
    <div class="login-title">
      <img class="login-logo" src="./img/title3.png" alt="" />
    </div>
    <div class="login-inpt">
      <a-input v-model="phone" placeholder="手机号" size="large">
        <a-icon slot="prefix" type="tablet" />
      </a-input>
      <a-input-password
        size="large"
        v-model="password"
        placeholder="密码"
        v-if="loginType == 1"
      >
        <a-icon slot="prefix" type="lock" />
      </a-input-password>
      <div class="login-verification" v-else>
        <a-input size="large" v-model="smsCode" placeholder="验证码">
          <a-icon slot="prefix" type="mail" />
          <a-tooltip slot="suffix" v-if="countDown > 0">
            <img class="login-code-right" src="./img/right.svg" alt="" />
          </a-tooltip>
        </a-input>
        <a-button
          size="large"
          class="login-code"
          :disabled="countDown > 0"
          @click="getCode"
        >
          {{ countDown > 0 ? countDown + "秒后重发" : "获取验证码" }}
        </a-button>
      </div>
      <div class="login-verification">
        <span></span>
        <a-button type="link" @click="forget">
          {{ loginType == 1 ? "手机验证码登录" : "密码登录" }}
        </a-button>
      </div>
      <a-button
        :loading="loading"
        size="large"
        type="primary"
        block
        @click="handLogin"
      >
        登录
      </a-button>
    </div>
    <div class="login-wrapper">
      <div class="login-wrapper-bottom">
        京ICP备2021035073号-1 民政工业总公司 V1.0
      </div>
    </div>
    <!-- <a-modal
      v-model="isSimpleness"
      title="为保护账号安全，首次登录需修改密码"
      :footer="null"
      :maskClosable="false"
      :closable="false"
      centered
    >
      <div class="mimaFlex">
        <prompts class="w300"> 密码由6-8位的大小写字母和数字组成 </prompts>
        <blank height="20"> </blank>
        <a-input-password
          class="w300"
          size="large"
          v-model="ruleForm.newPassword"
          placeholder="新密码"
        >
          <a-icon slot="prefix" type="lock" />
        </a-input-password>
        <blank height="20"> </blank>
        <a-input-password
          class="w300"
          size="large"
          v-model="ruleForm.xnewPassword"
          placeholder="再次输入新密码"
        >
          <a-icon slot="prefix" type="lock" />
        </a-input-password>
        <blank height="20"> </blank>

        <a-button
          class="w300"
          :loading="loading"
          size="large"
          type="primary"
          block
          @click="submitForm"
        >
          重置密码
        </a-button>
        <blank height="20"> </blank>
      </div>
    </a-modal> -->
  </div>
</template>

<script>
// import bgImg from './img/bgcpic.gif'
import bgImg from "./img/login-bgc.png";
import {
  authenticationForm,
  authenticationMobile,
  sendMobile,
  updatePassword
} from "@/http/url";
import { validatorPhone } from "@/assets/js/auth";
import { resetRouter } from "@/router/index";
export default {
  data() {
    return {
      bgImg,
      loginType: 1, // 登录方式 1 密码 2 验证码
      phone: "", //手机号
      password: "", // 密码
      smsCode: "", // 验证码
      countDown: 0, // 验证码倒计时
      countDownInterv: null,
      loading: false,
      isSimpleness: false, // 是简单密码
      ruleForm: {
        oldPassword: "",
        xnewPassword: "",
        newPassword: ""
      }
    };
  },
  created() {
    // localStorage.removeItem('token') // 登录前清除token  防止空白页
    localStorage.clear(); // 登录前清除token  防止空白页
    //清空动态路由 和左侧菜单 防止不同账号登录 左侧菜单不更新
    resetRouter();
    global.antRouter = [];
  },
  methods: {
    getCode() {
      let isPhone = validatorPhone(this.phone);
      if (isPhone) {
        // 获取验证码
        sendMobile(this.phone).then(res => {
          if (res.data.code == 0) {
            this.$message.success("发送成功");
            this.countDown = 60;
            this.countDownInterv = setInterval(() => {
              if (this.countDown > 0) {
                this.countDown--;
              } else {
                clearInterval(this.countDownInterv);
              }
            }, 1000);
          }
        });
      } else {
        this.$message.error("请输入正确的手机号！");
      }
    },
    forget() {
      // 忘记密码
      if (this.loginType == 2) {
        this.loginType = 1;
      } else {
        this.loginType = 2;
      }
    },
    // 判断密码强度
    getstrength(password) {
      let reg = /\d/;
      let a = reg.test(password);
      let p = /[a-z]/;
      let b = p.test(password); //true,说明有英文字母
      let c = /[A-Z]/;
      let s = c.test(password); //true,说明有大写英文字母
      console.log(a, b, s);
      if (a && b && s) {
        return true;
      } else {
        return false;
      }
    },
    submitForm() {
      if (!this.ruleForm.newPassword) {
        this.$message.error("请输入新密码");
        return false;
      }
      if (this.ruleForm.xnewPassword != this.ruleForm.newPassword) {
        this.$message.error("两次输入密码不一致");
        return false;
      }
      if (
        this.ruleForm.xnewPassword.length > 8 ||
        this.ruleForm.xnewPassword.length < 6
      ) {
        this.$message.error("密码由6-8位的大小写字母和数字组成");
        return false;
      }
      let isstrength = this.getstrength(this.ruleForm.xnewPassword);
      if (!isstrength) {
        this.$message.error("密码由6-8位的大小写字母和数字组成");
        return false;
      }
      updatePassword(this.ruleForm).then(res => {
        if (res.data.code == 0) {
          this.$message.success("密码修改成功,请重新登录");
          localStorage.setItem("token", "0");
          this.password = "";
          this.isSimpleness = false;
        }
      });
    },
    handLogin() {
      let isPhone = validatorPhone(this.phone);
      if (isPhone) {
        if (this.loginType == 1) {
          //密码登录
          if (!this.password) {
            this.$message.error("密码不能为空");
            return;
          }
          let loginData = {
            username: this.phone,
            password: this.password,
            systemFlag: "admin"
          };
          this.loading = true;
          authenticationForm(loginData).then(res => {
            if (res.data.code == 0) {
              // 登录成功
              localStorage.setItem("token", res.data.data);
              this.$message.success("登录成功");
              this.$router.push("/");
              this.loading = false;

              // let isStrength = this.getstrength(this.password);
              // if (!isStrength) {
              //   // 简单密码
              //   this.isSimpleness = true;
              //   this.$message.warning("登录成功，密码过于简单，请重置密码!");
              //   this.loading = false;
              // } else {
              //   this.$message.success("登录成功");
              //   this.$router.push("/");
              //   this.loading = false;
              // }
            } else {
              this.loading = false;
            }
          });
        } else {
          // 验证码登录
          if (!this.smsCode) {
            this.$message.error("验证码不能为空");
            return;
          }
          let loginData = {
            mobile: this.phone,
            smsCode: this.smsCode
          };
          this.loading = true;
          authenticationMobile(loginData).then(res => {
            if (res.data.code == 0) {
              // 登录成功
              this.$message.success("登录成功");
              localStorage.setItem("token", res.data.data);
              this.$router.push("/");
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
        }
      } else {
        this.$message.error("请输入正确的手机号！");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mimaFlex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.xititle {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
.login {
  /* height: 750px;
  width: 1440px; */
  // background-image: url('./img/login-bgc.png');
  // background-image: url('./img/bgcpic.gif');
  /* background-repeat: no-repeat; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 1000px;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.login-title {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-logo {
  width: 368px;
}
.login-tittle-name {
  width: 264px;
  height: 49px;
  // color: #fff;
  font-size: 33px;
  line-height: 49px;
  text-align: left;
  font-weight: bold;
}
.login-inpt {
  padding: 58px 0 48px 0;
  width: 368px;
  height: 320px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
.login-code {
  width: 120px;
  margin-left: 12px;
}
.login-verification {
  width: 368px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.login-code-right {
  height: 16px;
  width: 16px;
}
.login-verification-right {
  width: 56px;
  height: 22px;
  color: rgba(24, 144, 255, 1);
  font-size: 14px;
  line-height: 160%;
  text-align: left;
}
.login-wrapper {
  position: absolute;
  bottom: 18px;
  .login-wrapper-bottom {
    font-size: 12px;
    margin-top: 8px;
    // color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue